import { FormattedMessage, useIntl } from "react-intl";
import { ReactComponent as KeyTokenIcon } from "assets/images/icons/KeyToken.svg";
import { ReactComponent as PlusIcon } from "assets/images/iconsV2/plus.svg";
import Button from "components/v2/Button/Button";

interface EmptyDeveloperApiTokensStateProps {
  onClickGenerate: () => void;
}

export default function EmptyDeveloperApiTokensState({ onClickGenerate }: EmptyDeveloperApiTokensStateProps) {
  const intl = useIntl();

  return (
    <div className="d-flex justify-content-center align-items-center flex-column py-11xl">
      <div
        style={{ width: 48, height: 48 }}
        className="d-flex justify-content-center align-items-center p-lg mb-xl radius-sm border-1 border-solid border-secondary shadow-xs"
      >
        <KeyTokenIcon />
      </div>

      <div className="text-secondary-v2 text-md font-semibold mb-xs">
        <FormattedMessage
          id="settings.developerApiTokens.noTokensYet"
          defaultMessage="No API tokens generated yet"
        />
      </div>
      <div className="text-tertiary text-sm font-regular mb-3xl text-center" style={{ maxWidth: 352 }}>
        <FormattedMessage
          id="settings.developerApiTokens.noTokensYet.subtitle"
          defaultMessage="Generate a token to start integrating with the Cargobase API"
        />
      </div>

      <Button
        label={intl.formatMessage({
          id: "settings.developerApiTokens.generateToken",
          defaultMessage: "Generate token",
        })}
        iconLeft={<PlusIcon />}
        size="lg"
        onClick={onClickGenerate}
      />
    </div>
  );
}
